import { memo } from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PlaceLink } from 'utils/link';
import { IndexListItemButton } from 'components/styles_components/list';
import Place from 'utils/place';
import useMobile from 'hooks/use_mobile';
import CountCircle from 'components/count_circle';

const ListItem = ({ place }) => {
  const navigate = useNavigate();
  const isMobile = useMobile();
  const placeUtil = Place(place);
  const nameGridWidth = isMobile ? 12 : 6;

  const handleClick = () => navigate(PlaceLink(place.id));

  return (
    <IndexListItemButton className={placeUtil.htmlClass} onClick={handleClick}>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={nameGridWidth}>
          <Stack>
            <Typography variant="button">{place.name}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              <FormattedMessage id="place.address.data" />: {place.street}, {place.zipCode}{' '}
              {place.city}
            </Typography>
          </Stack>
        </Grid>
        {!isMobile && (
          <>
            <Grid textAlign="center" size={{ xs: 2 }}>
              <Typography variant="body2">{place.phone || '-'}</Typography>
            </Grid>
            <Grid textAlign="center" size={{ xs: 2 }}>
              <Typography variant="body2">{place.email || '-'}</Typography>
            </Grid>
            <Grid textAlign="center" size={{ xs: 1 }}>
              <CountCircle count={place.incomingInspectionsTotal} color="warning" />
            </Grid>
            <Grid textAlign="center" size={{ xs: 1 }}>
              <CountCircle count={place.overdueInspectionsTotal} color="error" />
            </Grid>
          </>
        )}
      </Grid>
    </IndexListItemButton>
  );
};

export default memo(ListItem);
